export const LIGHT_GREY_COLOR = "#F3F3F3";
export const PLACEHOLDER_GREY_COLOR = "#CECECE";
export const BLACK_COLOR = "black";
// export const LIGHT_BLUE_COLOR = 'rgb(95,131,178)';
export const LIGHT_BLUE_COLOR = "rgb(43,107,160)";
export const LIGHT_BG_COLOR = "rgb(243,243,243)";
